import React from 'react';
import { ThemeProvider } from '@emotion/react';
import type { SearchWidgetPageContent } from '@silvertours/common-landingpages-view';
import {
  AffiliateSearchForm,
  SearchFormLegacy,
} from '@silvertours/front-features';
import { Theme } from '@silvertours/front-shared';
import { useAffiliateColors } from './content';

const AffiliatePage = ({ color, showPoweredBy }: SearchWidgetPageContent) => {
  const affiliateColors = useAffiliateColors(color);
  const theme = {
    ...Theme.defaultTheme,
    colors: {
      ...Theme.defaultTheme.colors,
      brand: {
        ...Theme.defaultTheme.colors.brand,
        ...affiliateColors,
      },
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <SearchFormLegacy.SearchProvider>
        <AffiliateSearchForm color={color} showPoweredBy={showPoweredBy} />
      </SearchFormLegacy.SearchProvider>
    </ThemeProvider>
  );
};

export { AffiliatePage };
